import React from 'react';
import * as XLSX from 'xlsx';
import { Button, Alert } from 'react-bootstrap';
import { FaDownload, FaFileExcel } from 'react-icons/fa';

/**
 * Componente para descargar el template de Excel de carga de productos.
 * Genera un archivo XLSX con los encabezados requeridos para CargarProductosExcel.jsx.
 */
const DescargarTemplateExcel = () => {
    
    // ----------------------------------------------------
    // 1. DEFINICIÓN DE ENCABEZADOS REQUERIDOS
    // ----------------------------------------------------
    const headers = [
        "codigoProducto",
        "nombreProducto",
        "categoria",
        "proveedor",
        "atributo",
        "stock",
        "precioCosto",
        "multiplicador",
        "precioVenta",
        "precioFinal",
    ];

    // ----------------------------------------------------
    // 2. DATA DE EJEMPLO (COMO EN EL ARCHIVO CSV DEL USUARIO)
    // ----------------------------------------------------
    const dataSheet = [
        // Producto 1: TAZ222 (con sus 5 variantes)
        ["taz222", "taza", "deco", "maria", "boca", 10, 1000, 2],
        ["", "", "", "", "river", 10, 1000, 2], // Celdas vacías para el mismo producto
        ["", "", "", "", "velez", 10, 1000, 2],
        ["", "", "", "", "racing", 10, 1000, 2],
        ["", "", "", "", "boca unidos", 10, 1000, 2],
        
        // Producto 2: VEL255 (con sus 4 variantes)
        ["vel255", "velador", "deco", "juan", "rosa", 10, 1000, 2.5],
        ["", "", "", "", "rojo", 10, 1000, 2.5], // Celdas vacías para el mismo producto
        ["", "", "", "", "verde", 10, 1000, 2.5],
        ["", "", "", "", "amarillo", 10, 1000, 2.5],
    ];

    const generateExcel = () => {
        try {
            // 1. Crear la hoja de trabajo con los encabezados y datos
            const ws = XLSX.utils.aoa_to_sheet([headers, ...dataSheet]);

            // 2. Definición de ancho de columnas (AJUSTADO)
            const wscols = [
                { wch: 15 }, // codigoProducto
                { wch: 30 }, // nombreProducto
                { wch: 15 }, // categoria
                { wch: 20 }, // proveedor
                { wch: 15 }, // atributo
                { wch: 8 },  // stock
                { wch: 15 }, // precioCosto
                { wch: 15 }, // multiplicador
                 { wch: 15 }, // precioVenta
                  { wch: 15 }, // precioFinal
            ];
            ws['!cols'] = wscols;

            // 3. Crear el libro de trabajo
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Productos");

            // 4. Escribir y descargar el archivo
            XLSX.writeFile(wb, "Template_Carga_Productos.xlsx");

        } catch (error) {
            console.error("Error al generar el archivo Excel:", error);
            alert("Hubo un error al generar el archivo. Asegúrate de tener la librería XLSX instalada.");
        }
    };

    return (
        <Alert variant="info" className="d-flex align-items-center justify-content-between p-3 shadow-sm">
            <div>
                <FaFileExcel className="me-2 fs-4" />
                <span className="fw-bold">Descarga el Template para la Carga Masiva:</span>
                <p className="mb-0 small text-muted">Utiliza este archivo para asegurar que los encabezados son correctos.</p>
            </div>
            
            <Button 
                variant="success" 
                onClick={generateExcel}
                className="fw-bold shadow-sm"
            >
                <FaDownload className="me-2" />
                Descargar Template
            </Button>
        </Alert>
    );
};

export { DescargarTemplateExcel };